"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressModel = void 0;
const AddressModel = {
    type: Object,
    schema: {
        address1: { type: String },
        address2: { type: String },
        city: { type: String },
        state: { type: String },
        zip: { type: String },
        country: { type: String },
        region: { type: String },
        latitude: { type: Number },
        longitude: { type: Number },
    },
};
exports.AddressModel = AddressModel;
